module.exports = __webpack_public_path__ + "static/gloval-5964078d68d9198a8ab183c84d81068d.png";